import React from 'react';
import MayorListItem from './MayorListItem';

const MayorList: React.FunctionComponent<any> = ({type, mayors, onClick}) => {
  const listItems = mayors ? mayors.map((mayor: any, index: number) =>
    <MayorListItem type={type} onClick={onClick} key={`list-item-${index}`} mayor={mayor} />
  ) : null;

  return (
    <div className="border-t-4 md:border-t-0 border-black overflow-y-auto py-4 p-2.5 md:px-6 mt-4 md:mt-0 md:py-2.5" style={{height: 'calc(100% - 120px)'}}>
      {listItems}
    </div>
  )
}

export default MayorList;